mutation CreateStream($input: CreateStreamInput!) {
  createStream(input: $input) {
    id
  }
}
